import React from "react";
import { Header, Segment } from "semantic-ui-react";
import IntroductionTemplate from "./IntroductionTemplate";
import AssignmentTemplateSPV from "./AssignmentTemplateSPV";
import AssignmentTemplateCustomer from "./AssignmentTemplateCustomer";

const AdditionalDocuments = ({ dealerId }) => {
  return (
    <Segment>
      <Header as="h3">Introduction Template</Header>
      <IntroductionTemplate dealerId={dealerId} />
      <Header as="h3">Assignment Template from SPV</Header>
      <AssignmentTemplateSPV dealerId={dealerId} />
      <Header as="h3">Assignment Template from Customer</Header>
      <AssignmentTemplateCustomer dealerId={dealerId} />
    </Segment>
  );
};

export default AdditionalDocuments;
